import React, { ComponentType, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

export const Loadable = <P extends object>(Component: ComponentType<P>) =>
  function L(props: P) {
    return (
      <Suspense
        fallback={<CircularProgress sx={{ display: 'block', mx: 'auto' }} />}
      >
        <Component {...props} />
      </Suspense>
    );
  };
